var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"rect1 line"}),_c('div',{staticClass:"rect2 line"}),_c('div',{staticClass:"rect3 line"}),_c('div',{staticClass:"rect4 line"}),_c('div',{staticClass:"rect5 line"})]),_c('div',{staticClass:"center-text"},[_vm._v("加载中")])])
}]

export { render, staticRenderFns }